module.exports = __webpack_public_path__ + "static/media/witch.1b946685.mp3";